import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DashboardLayout from "../layout/index";
import axios from 'axios';
import { toast } from "react-toastify";

const ClinicStaffEdit = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const receptionistData = location.state.receptionistData;
    console.log(receptionistData,"receptionistData");
    
    const [formData, setFormData] = useState({
        userId: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobile: '',
        email: '',
        roles: ['USER'],
        password: '',
        active: true,
        tenantId: localStorage.getItem("tenantId")
    });
    
    const [errors, setErrors] = useState({
        userId: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobile: '',
        email: ''
    });
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const token = localStorage.getItem("auth_token");
    const API_BASE = process.env.REACT_APP_API_URL;
    const [receptionists, setReceptionists] = useState([]);

    // Populate form with receptionist data when editing
    useEffect(() => {
        if (location.state?.receptionistData && location.state?.isEdit) {
            const receptionistData = location.state.receptionistData;
            console.log("Receptionist data received:", receptionistData);
            
            setFormData({
                userId: receptionistData.userId || '',
                firstName: receptionistData.firstName || '',
                middleName: receptionistData.middleName || '',
                lastName: receptionistData.lastName || '',
                mobile: receptionistData.mobile || '',
                email: receptionistData.email || '',
                roles: receptionistData.roles || ['USER'],
                password: '', // Don't populate password for security
                active: receptionistData.active !== undefined ? receptionistData.active : true,
                tenantId: localStorage.getItem("tenantId")
            });
        }
    }, [location.state]);
    // useEffect(() => {
    //     fetchList();
    // }, [fetchList]);

    const generateUserIdSuggestions = (firstName, mobile, existingUserIds) => {
        const suggestions = [];
        
        if (firstName && mobile && mobile.length >= 4) {
            const firstNameLower = firstName.toLowerCase();
            const mobileLast4 = mobile.substring(mobile.length - 4);
            const suggestion = `${firstNameLower}@${mobileLast4}`;
            
            if (!existingUserIds.includes(suggestion.toLowerCase())) {
                suggestions.push(suggestion);
            }
        }
        
        return suggestions;
    };

    // const fetchList = useCallback(async () => {
    //     const token = localStorage.getItem("auth_token");
    //     const tenantId = localStorage.getItem("tenantId");

    //     try {
    //         const res = await fetch(
    //             `${API_BASE}auth/clinic-user-details/${tenantId}?role=USER`,
    //             {
    //                 method: "GET",
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${token}`,
    //                     // tenantId: tenantId,
    //                 },
    //             }
    //         );
    //         const data = await res.json();
    //         console.log(data, "receptionists");
    //         setReceptionists(data);
    //         const userIdsString = data.map(receptionist => receptionist.userId).join(',');
    //         console.log(userIdsString,"userIdsString");
    //         // setLoading(false);
    //     } catch (error) {
    //         console.error("Failed to fetch receptionist data:", error);
    //         toast.error("Failed to fetch receptionist data");
    //         // setLoading(false);
    //     }
    // }, [API_BASE]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        
        let filteredValue = value;
        
        // Filter input based on field type
        if (name === 'firstName' || name === 'middleName' || name === 'lastName') {
            // Only allow letters and spaces for name fields
            filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
        } else if (name === 'mobile') {
            // Only allow numbers for mobile field
            filteredValue = value.replace(/\D/g, '');
        }
        
        setFormData(prev => ({
            ...prev,
            [name]: filteredValue
        }));
        
        // Generate suggestions for userId if it's a duplicate
        if (name === 'userId' && filteredValue.trim()) {
            const existingUserIds = receptionists.map(r => r.userId.toLowerCase());
            if (existingUserIds.includes(filteredValue.toLowerCase())) {
                // Generate suggestions based on firstName and mobile
                const suggestions = generateUserIdSuggestions(formData.firstName, formData.mobile, existingUserIds);
                // Suggestions are now handled in error messages
            }
        }
        
        // Also generate suggestions when firstName or mobile changes
        if ((name === 'firstName' || name === 'mobile') && formData.userId.trim()) {
            const existingUserIds = receptionists.map(r => r.userId.toLowerCase());
            if (existingUserIds.includes(formData.userId.toLowerCase())) {
                const suggestions = generateUserIdSuggestions(
                    name === 'firstName' ? filteredValue : formData.firstName,
                    name === 'mobile' ? filteredValue : formData.mobile,
                    existingUserIds
                );
                // Suggestions are now handled in error messages
            }
        }
        
        // Real-time validation on every keystroke
        validateField(name, filteredValue);
    };

    const validateField = (fieldName, value) => {
        let error = '';
        
        switch (fieldName) {
            case 'userId':
                if (!value.trim()) {
                    error = 'User ID is required';
                } else {
                    // Check if userId already exists
                    const existingUserIds = receptionists.map(r => r.userId.toLowerCase());
                    if (existingUserIds.includes(value.toLowerCase())) {
                        // Generate suggestion for the error message
                        const suggestions = generateUserIdSuggestions(formData.firstName, formData.mobile, existingUserIds);
                        if (suggestions.length > 0) {
                            error = `User ID already exists. Try a different one. Suggested: ${suggestions[0]}`;
                        } else {
                            error = 'User ID already exists. Try a different one.';
                        }
                    }
                }
                break;
            case 'firstName':
                if (!value.trim()) {
                    error = 'First name is required';
                } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
                    error = 'First name can only contain letters and spaces';
                }
                break;
            case 'middleName':
                if (value.trim() && !/^[a-zA-Z\s]+$/.test(value.trim())) {
                    error = 'Middle name can only contain letters and spaces';
                }
                break;
            case 'lastName':
                if (value.trim() && !/^[a-zA-Z\s]+$/.test(value.trim())) {
                    error = 'Last name can only contain letters and spaces';
                }
                break;
            case 'mobile':
                if (!value.trim()) {
                    error = 'Mobile number is required';
                } else if (!/^\d{10}$/.test(value)) {
                    error = 'Please enter a valid 10-digit mobile number';
                }
                break;
            case 'email':
                if (!value.trim()) {
                    error = 'Email is required';
                } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                    error = 'Please enter a valid email address';
                }
                break;
            default:
                break;
        }
        
        setErrors(prev => ({
            ...prev,
            [fieldName]: error
        }));
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {
            userId: '',
            firstName: '',
            middleName: '',
            lastName: '',
            mobile: '',
            email: ''
        };

        if (!formData.userId.trim()) {
            newErrors.userId = 'User ID is required';
            valid = false;
        } else {
            // Check if userId already exists
            const existingUserIds = receptionists.map(r => r.userId.toLowerCase());
            if (existingUserIds.includes(formData.userId.toLowerCase())) {
                // Generate suggestion for the error message
                const suggestions = generateUserIdSuggestions(formData.firstName, formData.mobile, existingUserIds);
                if (suggestions.length > 0) {
                    newErrors.userId = `User ID already exists. Try a different one. Suggested: ${suggestions[0]}`;
                } else {
                    newErrors.userId = 'User ID already exists. Try a different one.';
                }
                valid = false;
            }
        }

        if (!formData.firstName.trim()) {
            newErrors.firstName = 'First name is required';
            valid = false;
        } else if (!/^[a-zA-Z\s]+$/.test(formData.firstName.trim())) {
            newErrors.firstName = 'First name can only contain letters and spaces';
            valid = false;
        }

        // Validate middle name if provided
        if (formData.middleName.trim() && !/^[a-zA-Z\s]+$/.test(formData.middleName.trim())) {
            newErrors.middleName = 'Middle name can only contain letters and spaces';
            valid = false;
        }

        // Validate last name if provided
        if (formData.lastName.trim() && !/^[a-zA-Z\s]+$/.test(formData.lastName.trim())) {
            newErrors.lastName = 'Last name can only contain letters and spaces';
            valid = false;
        }

        if (!formData.mobile.trim()) {
            newErrors.mobile = 'Mobile number is required';
            valid = false;
        } else if (!/^\d{10}$/.test(formData.mobile)) {
            newErrors.mobile = 'Please enter a valid 10-digit mobile number';
            valid = false;
        }

        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
            valid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        if (!validateForm()) {
            setIsSubmitting(false);
            return;
        }

       console.log(location.state?.receptionistData,"fcgvhbjnkm")
        const receptionistId = location.state?.receptionistData?.userId;
        try {
                     const updatePayload = {
                    email: formData.email,
                    mobile: formData.mobile,
                    firstName: formData.firstName,
                    middleName: formData.middleName,
                    lastName: formData.lastName
                };
             const res = await fetch(`${API_BASE}auth/update-user-details/${receptionistId}`, {
               method: "PUT",
               headers: {
                 'Content-Type': 'application/json',
                 Authorization: `Bearer ${token}`,
                //  tenantId: localStorage.getItem("tenantId")
               },
               body: JSON.stringify(updatePayload),
             });
      
            const result = await res.json();
            // setIsLoggingIn(false);
           
            console.log("Update result:", result,res.status);
      
            if (res.status === 200) {
                const res3 = await fetch(`${API_BASE}auth/update-user-details/${receptionistId}`, {
                    method: "PUT",
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${token}`,
                      tenantId: localStorage.getItem("tenantId")
                    },
                    body: JSON.stringify(updatePayload),
                  });
                  const result3 = await res3.json();
                  if (res3.status === 200) {
                    toast.success("Staff updated successfully");
                    navigate("/receptionistList");
                  }
             
            } else if (result.error) {
              toast.error(result.error);
            } else {
              toast.error(result.message || "Update failed.");
            }
          } catch (error) {
            console.error("API error:", error);
            toast.error("Something went wrong while updating doctor.");
            // setIsLoggingIn(false);
          }

        // try {
        //     if (isEdit && receptionistId) {
        //         // Update existing receptionist with the new API endpoint and payload format
        //         const updatePayload = {
        //             email: formData.email,
        //             mobile: formData.mobile,
        //             firstName: formData.firstName,
        //             lastName: formData.lastName
        //         };
                
        //         await axios.put(
        //             `${API_BASE}auth/update-user-details/${receptionistId}`,
        //             updatePayload,
        //             {
        //                 headers: {
        //                     Authorization: `Bearer ${token}`,
        //                     'Content-Type': 'application/json',
        //                     tenantId: localStorage.getItem("tenantId")
        //                 }
        //             }
        //         );
        //         toast.success("Staff updated successfully");
        //         navigate('/receptionistList');
        //     } else {
        //         // Create new receptionist
        //         await axios.post(
        //             `${API_BASE}auth/register`,
        //             formData,
        //             {
        //                 headers: {
        //                     Authorization: `Bearer ${token}`,
        //                     'Content-Type': 'application/json'
        //                 }
        //             }
        //         );
                
        //         // Second API call with tenantId in header
        //         try {
        //             const secondApiResponse = await axios.post(
        //                 `${API_BASE}auth/register`,
        //                 formData,
        //                 {
        //                     headers: {
        //                         Authorization: `Bearer ${token}`,
        //                         'Content-Type': 'application/json',
        //                         tenantId: localStorage.getItem("tenantId")
        //                     }
        //                 }
        //             );
                    
        //             console.log("Second API response:", secondApiResponse.data);
        //         } catch (secondApiError) {
        //             console.error("Second API call failed:", secondApiError);
        //             toast.warning("Staff registered but additional setup failed");
        //         }
                
        //         toast.success("Staff onboarded successfully");
        //         setFormData({
        //             userId: '',
        //             firstName: '',
        //             middleName: '',
        //             lastName: '',
        //             mobile: '',
        //             email: '',
        //             role: 'USER',
        //             password: '',
        //             active: true,
        //             tenantId: localStorage.getItem("tenantId")
        //         });
        //     }
            
        //     setErrors({});
        //     // fetchList();

        // } catch (err) {
        //     console.error("Onboarding error:", err.response || err);
        //     const errorMessage = err.response?.data?.error || 
        //                        err.response?.data?.message || 
        //                        "Failed to onboard staff. Please try again.";
        //     toast.error(errorMessage);
        // }
         finally {
            setIsSubmitting(false);
        }
    };
    const userIdsString = receptionists.map(receptionist => receptionist.userId).join(',');
    console.log(userIdsString,"userIdsString");
    return (
        <DashboardLayout>
            <div className="w-full mx-auto bg-[#f1f8f7] p-6 rounded-lg shadow-md mt-10 max-w-4xl">
                <h1 className="text-2xl font-bold text-[#004276] mb-6">
                    {location.state?.isEdit ? 'Edit Organization Staff' : 'Onboard Organization Staff'}
                </h1>


                <form onSubmit={handleSubmit} noValidate>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* <div className="mb-4">
                            <label className="block text-[#004276] font-medium mb-2" htmlFor="userId">
                                User ID *
                            </label>
                            <input
                                type="text"
                                id="userId"
                                name="userId"
                                placeholder="Enter user ID ex- firstname@last 4 digit of mobile number"
                                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                    errors.userId ? 
                                    'border-red-500 focus:ring-red-500' : 
                                    'border-gray-300 focus:ring-blue-500'
                                } ${location.state?.isEdit ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                value={formData.userId}
                                onChange={handleChange}
                                disabled={location.state?.isEdit}
                            />
                            {errors.userId && (
                                <p className="mt-1 text-sm text-red-600">{errors.userId}</p>
                            )}
                        </div> */}

                        <div className="mb-4">
                            <label className="block text-[#004276] font-medium mb-2" htmlFor="firstName">
                                First Name *
                            </label>
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                placeholder="Enter first name"
                                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                    errors.firstName ? 
                                    'border-red-500 focus:ring-red-500' : 
                                    'border-gray-300 focus:ring-blue-500'
                                }`}
                                value={formData.firstName}
                                onChange={handleChange}
                            />
                            {errors.firstName && (
                                <p className="mt-1 text-sm text-red-600">{errors.firstName}</p>
                            )}
                        </div>

                        <div className="mb-4">
                            <label className="block text-[#004276] font-medium mb-2" htmlFor="middleName">
                                Middle Name
                            </label>
                            <input
                                type="text"
                                id="middleName"
                                name="middleName"
                                placeholder="Enter middle name"
                                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                    errors.middleName ? 
                                    'border-red-500 focus:ring-red-500' : 
                                    'border-gray-300 focus:ring-blue-500'
                                }`}
                                value={formData.middleName}
                                onChange={handleChange}
                            />
                            {errors.middleName && (
                                <p className="mt-1 text-sm text-red-600">{errors.middleName}</p>
                            )}
                        </div>

                        <div className="mb-4">
                            <label className="block text-[#004276] font-medium mb-2" htmlFor="lastName">
                                Last Name
                            </label>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                placeholder="Enter last name"
                                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                    errors.lastName ? 
                                    'border-red-500 focus:ring-red-500' : 
                                    'border-gray-300 focus:ring-blue-500'
                                }`}
                                value={formData.lastName}
                                onChange={handleChange}
                            />
                            {errors.lastName && (
                                <p className="mt-1 text-sm text-red-600">{errors.lastName}</p>
                            )}
                        </div>

                        <div className="mb-4">
                            <label className="block text-[#004276] font-medium mb-2" htmlFor="mobile">
                                Mobile *
                            </label>
                            <input
                                type="tel"
                                id="mobile"
                                name="mobile"
                                placeholder="Enter mobile number"
                                maxLength="10"
                                readOnly
                                className={`w-full px-3 py-2 border rounded-md bg-gray-100 cursor-not-allowed focus:outline-none ${
                                    errors.mobile ? 
                                    'border-red-500' : 
                                    'border-gray-300'
                                }`}
                                value={formData.mobile}
                            />
                            {errors.mobile && (
                                <p className="mt-1 text-sm text-red-600">{errors.mobile}</p>
                            )}
                        </div>

                        <div className="mb-4">
                            <label className="block text-[#004276] font-medium mb-2" htmlFor="email">
                                Email *
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Enter email"
                                readOnly
                                className={`w-full px-3 py-2 border rounded-md bg-gray-100 cursor-not-allowed focus:outline-none ${
                                    errors.email ? 
                                    'border-red-500' : 
                                    'border-gray-300'
                                }`}
                                value={formData.email}
                            />
                            {errors.email && (
                                <p className="mt-1 text-sm text-red-600">{errors.email}</p>
                            )}
                        </div>
                    </div>

                    <div className="flex justify-end space-x-4 mt-6">
                        <button
                            type="button"
                            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onClick={() => {
                                setFormData({
                                    userId: '',
                                    firstName: '',
                                    middleName: '',
                                    lastName: '',
                                    mobile: '',
                                    email: '',
                                    roles: ['USER'],
                                    password: '',
                                    active: true,
                                    tenantId: localStorage.getItem("tenantId")
                                });
                                setErrors({
                                    userId: '',
                                    firstName: '',
                                    middleName: '',
                                    lastName: '',
                                    mobile: '',
                                    email: ''
                                });
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={`px-4 py-2 bg-gradient-to-r from-[#004172] to-[#3cba84] text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                isSubmitting ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90'
                            }`}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Processing...' : (location.state?.isEdit ? 'Update Staff' : 'Onboard Staff')}
                        </button>
                    </div>
                </form>
            </div>
        </DashboardLayout>
    );
};

export default ClinicStaffEdit;